/* eslint-disable */
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { TranslatePipe, provideTranslateService } from '@ngx-translate/core';
import { provideAppTranslationLoader } from './core/translate/translation-loader';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from './core/core.module';
import { environment } from 'environments/environment';
import { ToastModule } from './toast/toast.module';
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import {
  FIREBASE_APP,
  FIREBASE_AUTH,
  FIREBASE_FIRESTORE
} from './core/firebase/firebase.tokens';
import { MatTooltipModule } from '@angular/material/tooltip';

export function getCurrentLocale(): string {
  return localStorage.getItem(environment.localStorage.language) || 'en';
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    CoreModule,
    MatTooltipModule,
    ToastModule.forRoot(),
    TranslatePipe
  ],
  providers: [
    provideTranslateService({ loader: provideAppTranslationLoader() }),
    {
      provide: FIREBASE_APP,
      useFactory: () => initializeApp(environment.firebase)
    },
    { provide: FIREBASE_AUTH, useFactory: getAuth, deps: [FIREBASE_APP] },
    {
      provide: FIREBASE_FIRESTORE,
      useFactory: getFirestore,
      deps: [FIREBASE_APP]
    },
    {
      provide: LOCALE_ID,
      useValue: getCurrentLocale()
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
